import React, {useContext, useState} from 'react';
import logo from '../../accets/img/Logo.png'
import exit from '../../accets/img/exit.png'
import './Logo.css'
import {Context} from "../../index";

const Logo = () => {

    const {userStore} = useContext(Context)

    const [activeBurger, setActiveBurger] = useState(false)


    return (
        <div className="pre__logo">
            <div className={!activeBurger ? "hamburger" : "hamburger active"}
                 onClick={() => setActiveBurger(!activeBurger)}>
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
            </div>
            <div className={!activeBurger ? "burger__logo__block" : "burger__logo__block active"}>
                <div className="logo__brg">
                    <img src={logo} alt={logo}/>
                </div>
                <div className="login__brg">
                    <div className="name">
                        <div className="priv">Приветствую,</div>
                        <div className="login__name">{userStore.user.secondName}</div>
                    </div>
                    <div className="exit" onClick={() => userStore.logout()}>
                        <img src={exit} alt={exit}/>
                    </div>
                </div>
            </div>
            <div className="logo">
                <img src={logo} alt={logo}/>
            </div>
            <div className="login__block">
                <div className="name">
                    <div className="priv">Приветствую,</div>
                    <div className="login__name">{userStore.user.secondName}</div>
                </div>
                <div className="exit" onClick={() => userStore.logout()}>
                    <img src={exit} alt={exit}/>
                </div>
            </div>

        </div>
    );
};

export default Logo;